import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import AllApplications from "Main/Views/AllApplications";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// const admin = localStorage.getItem("admin_details");

// @mui icons
import Icon from "@mui/material/Icon";
import Testimonials from "Main/Views/Testimonials";

import Blogs from "Main/Views/Blogs";
import WebContacts from "Main/Views/WebContacts";
import Notifications from "Main/Views/Notifications";
import AboutUs from "Main/Views/AboutUs";
import BlogCategories from "Main/Views/BlogCategories";
import Aluminis from "Main/Views/Aluminis";
import Events from "Main/Views/Events";
import Gallery from "Main/Views/Gallery";
import Courses from "Main/Views/Courses";
import FranchiseEnquiry from "Main/Views/FarnchiseEnquiry";
import SocialMedia from "Main/Views/SocialMedia";
import SchoolEnquiry from "Main/Views/SchoolEnquiry";
import Banners from "Main/Views/Banner";
import Exams from "Main/Views/Competitive_Exams";
import CountsList from "Main/Views/AboutUsCount";
import TeamsList from "Main/Views/Teams";
import FaqList from "Main/Views/Faq";
import AmenitiesList from "Main/Views/Amenities";
import NavbarTextList from "Main/Views/NavbarSlider";
import RequestDemoList from "Main/Views/RequestDemo";
import YoutubeSliderList from "Main/Views/YoutubeSlider";
import AddUpdatePage from "Main/Views/AbacusSchool";
import AbacusCourseList from "Main/Views/AbacusCourse";
import AddUpdateAllYoutube from "Main/Views/AllYoutube";

let users = localStorage.getItem("admin_details");
let user;

if (users) {
  user = JSON.parse(users);
}

let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "About Us",
    key: "careers",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/aboutus",
    component: <AboutUs />,
  },
  {
    type: "collapse",
    name: "About Us Count",
    key: "counts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/count",
    component: <CountsList />,
  },
  {
    type: "collapse",
    name: "Navbar Slider",
    key: "navbartexts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/navbartexts",
    component: <NavbarTextList />,
  },
  {
    type: "collapse",
    name: "Amenities",
    key: "amenities",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/amenities",
    component: <AmenitiesList />,
  },
  {
    type: "collapse",
    name: "Teams",
    key: "teams",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/teams",
    component: <TeamsList />,
  },
  {
    type: "collapse",
    name: "Banner",
    key: "banner",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/banner",
    component: <Banners />,
  },
  {
    type: "collapse",
    name: "Blog Categories",
    key: "career",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogcategories",
    component: <BlogCategories />,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "blogs",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogs",
    component: <Blogs />,
  },
  {
    type: "collapse",
    name: "Courses",
    key: "courses",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/courses",
    component: <Courses />,
  },
  {
    type: "collapse",
    name: "Competitive Exams",
    key: "exams",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/exams",
    component: <Exams />,
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/events",
    component: <Events />,
  },
  {
    type: "collapse",
    name: "Alumini",
    key: "alumini",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/alumini",
    component: <Aluminis />,
  },
  {
    type: "collapse",
    name: "Gallery",
    key: "gallery",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },
  {
    type: "collapse",
    name: "FAQ",
    key: "faq",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/faqs",
    component: <FaqList />,
  },
  {
    type: "collapse",
    name: "Home Youtube Slider",
    key: "youtubeslider",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/youtubeslider",
    component: <YoutubeSliderList />,
  },
  {
    type: "collapse",
    name: "Testimonials",
    key: "testimonials",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/testimonials",
    component: <Testimonials />,
  },
  {
    type: "collapse",
    name: "Social Meida",
    key: "socialmedia",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/socialmedia",
    component: <SocialMedia />,
  },
  {
    type: "collapse",
    name: "Farnchise Enquiry",
    key: "franchiseenq",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/franchiseenq",
    component: <FranchiseEnquiry />,
  },
  {
    type: "collapse",
    name: "Abacus School Page",
    key: "abacusschool",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/abacusschool",
    component: <AddUpdatePage />,
  },
  {
    type: "collapse",
    name: "Abacus Near Me",
    key: "abacuscourse",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/abacuscourse",
    component: <AbacusCourseList />,
  },
  {
    type: "collapse",
    name: "All Youtube",
    key: "allyoutube",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/allyoutube",
    component: <AddUpdateAllYoutube />,
  },
  {
    type: "collapse",
    name: "School Enquiry",
    key: "schoolenq",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/schoolenq",
    component: <SchoolEnquiry />,
  },
  {
    type: "collapse",
    name: "Demo Request",
    key: "demoreq",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/demoreq",
    component: <RequestDemoList />,
  },
  {
    type: "collapse",
    name: "Contacts",
    key: "contacts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contacts",
    component: <WebContacts />,
  },

  // SUBJECT and LEVEL Routes
  // {
  //   type: "collapse",
  //   name: "Topics",
  //   key: "topics",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/topics",
  //   component: <Topics />,
  // },
  // {
  //   type: "collapse",
  //   name: "Levels",
  //   key: "levels",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/levels",
  //   component: <Levels />,
  // },
  // {
  //   type: "collapse",
  //   name: "Questions",
  //   key: "questions",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/questions",
  //   component: <Questions />,
  // },
  // {
  //   type: "collapse",
  //   name: "Test Series",
  //   key: "testseries",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/testseries",
  //   component: <TestSeries />,
  // },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/users",
  //   component: <Users />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
];

let newRoutes = [];

if (user?.employee_type === "question_creater") {
  // console.log(user);
  routes.filter((item) => {
    if (
      item.route === "/questions" ||
      item.route === "/subjects" ||
      item.route === "/levels" ||
      item.route === "/topics" ||
      item.route === "/dashboard"
    ) {
      newRoutes.push(item);
    }
  });
}
if (user?.role == "superadmin") {
  newRoutes = routes;
}
routes = newRoutes;
export default routes;
